// extracted by mini-css-extract-plugin
module.exports = {"card":"SmptPcPosCard_card__1AxF3","text":"SmptPcPosCard_text__10tMj","text-ltr":"SmptPcPosCard_text-ltr__2dy92","button":"SmptPcPosCard_button__2jDqb"};